import React, { useState, useEffect } from 'react';

const TypewriterEffect = ({ text, typingSpeed = 65 }) => {
  const [displayedText, setDisplayedText] = useState('');
  const [showCursor, setShowCursor] = useState(true);

  useEffect(() => {
    let index = 0;
    const timer = setInterval(() => {
      if (index <= text.length) {
        setDisplayedText(text.slice(0, index));
        index++;
      } else {
        clearInterval(timer);
        setTimeout(() => setShowCursor(false), 600); // Hide cursor after typing is done
      }
    }, typingSpeed);

    return () => clearInterval(timer);
  }, [text, typingSpeed]);

  return (
    <>
      {displayedText}
      {showCursor && <span className="typing-cursor">|</span>}
    </>
  );
};

export default TypewriterEffect;
